import { getHomeNews } from 'actions/news';

export default store => ({
	path: ':id',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./container.js').default;
					cb(null, component);
				},
				'News',
			),
		onEnter: ({ params: { lang, id } }) => {
			store.dispatch(getHomeNews(lang, id));
		},
	},
});



// WEBPACK FOOTER //
// ./src/routes/News/News/index.js